import 'rxjs'

import { storyLockedOrReadonlyAccessor } from '~/redux/appReducer'
import { getStoryAns } from '~/redux/storyData'

const typesOfInterest = [
  'ellipsis.draftEditor.editorContentUpdate',
  'ellipsis.draftEditor.headlineContentState',
  'ellipsis.draftEditor.subheadlineContentState',
]

const dirtyEpic = (action$, store, { serviceResolver }) =>
  action$
    .filter((action) => ~typesOfInterest.indexOf(action.type))
    .filter((action) => {
      if (storyLockedOrReadonlyAccessor(store.getState())) {
        return false
      }

      return !!action
    })
    .map((action) => {
      const storyService = serviceResolver('storyService')
      /**
       * Fetching the storyData and adding
       * the isDirty property to be accessible in React
       */
      const reduxStory = getStoryAns(store.getState())
      if (reduxStory) {
        reduxStory.isDirty = true

        storyService.setStory(reduxStory, true)
      }
      storyService.isDirty(true)
    })
    .filter((action) => false)

export default dirtyEpic
